import { useMemo } from 'react'
import { FetchPolicy } from '@apollo/client'
import { Branch } from 'inventory-web'
import { useBranchesQuery } from '../graphql'
import useCompanyId from './useCompanyId'

function sortByName( a: { name: string }, b: { name: string } ) {
	const aName = a.name.toLowerCase()
	const bName = b.name.toLowerCase()
	if ( aName < bName ) {
		return -1
	}
	if ( aName > bName ) {
		return 1
	}
	return 0
}

export function filterBranches( search: string, branches: Branch[] ) {
	if ( search === '' ) {
		return branches
	} else {
		const searchExpr = new RegExp( search, 'i' )
		return branches.filter( ( branch ) => searchExpr.exec( branch.name ) )
	}
}

export default function useBranchesSearch( search: string, debounceKey = 'branches-debounce', fetchPolicy: FetchPolicy = 'no-cache' ) {
	const companyId = useCompanyId()
	const { data, loading, ...result } = useBranchesQuery( {
		context: { debounceKey },
		fetchPolicy,
		variables: { companyId }
	} )

	const branches = useMemo<Branch[]>( () => {
		if ( !loading && data?.branches ) {
			return data.branches.sort( sortByName )
		}
		return []
	}, [ data, loading ] )

	const filteredBranches = useMemo<Branch[]>( () => filterBranches( search, branches ), [ branches, search ] )

	return {
		filteredBranches,
		branches: data?.branches ?? [],
		loading,
		...result,
	}
}
